import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedRating } from '@/store/selectors/ratingSelectors';
import { setSelectedRating } from '@/store/reducers/testRatingSlice';
import StarRatingSelector from '@/components/features/RatingSelector/StarRatingSelector';


interface RatingSelectorProps {
	maxRating?: number,
	starSize?: number,
	autoWidth?: boolean,
}

const RatingSelector: React.FC<RatingSelectorProps> = ({ maxRating, starSize, autoWidth  }) => {
	const dispatch = useDispatch();
	const selectedRating = useSelector(selectSelectedRating);

	const handleRatingSelect = useCallback((rating: number) => {
		dispatch(setSelectedRating(rating));

	}, [dispatch]);

	return (
		<StarRatingSelector
			maxRating={maxRating}
			starSize={starSize}
			selectedRating={selectedRating}
			onRatingSelect={handleRatingSelect}
			autoWidth={autoWidth}
		/>
	);
};

export default React.memo(RatingSelector);